import amplitude from 'amplitude-js';

const KEY = process.env.REACT_APP_AMPLITUDE_API_KEY;

amplitude.getInstance().init(KEY, null);

export { amplitude };